import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box, Flex } from 'components/ui';
import checkoutUtils from 'utils/Checkout';
import localeUtils from 'utils/LanguageLocale';
import { colors } from 'style/config';

import ShippingMethodItems from 'components/FrictionlessCheckout/ShippingMethods/ShippingMethodItems';

const STANDARD = !localeUtils.isCanada() ? 'Standard' : localeUtils.isFrench() ? 'gratuite' : 'Free';

function ShippingMethod(props) {
    const {
        locales,
        isReplenOnly,
        shippingMethod,
        isLastItem,
        shippingGroup,
        shippingGroupType,
        handleOnClickShippingMethodSelected,
        getShippingFee,
        shippingMethodSelected,
        isSplitEDDEnabled,
        orderHasReplen,
        standardItemsQuantity,
        replenishItemsQuantity,
        isPhysicalGiftCard,
        isElectronicShippingGroup,
        isEditView,
        showAutoReplenishModal,
        openAutoReplenishProductsModal,
        standardBasket,
        message,
        handleCheckboxChange,
        setShippingMethod
    } = props;

    const shipFee = getShippingFee(shippingMethod?.shippingFee);
    const isSelected = shippingMethodSelected.shippingMethodId === shippingMethod.shippingMethodId;
    const showSplitEDD = isSplitEDDEnabled && checkoutUtils.hasDeliveryGroups([shippingMethod]);
    const deliveryGroups = showSplitEDD && checkoutUtils.computeDeliveryGroups(shippingGroup, shippingGroupType, shippingMethod);

    const title = isReplenOnly && shippingMethod?.shippingMethodType === STANDARD ? locales.shippingMethodType : shippingMethod?.shippingMethodType;

    return (
        <Box
            marginX={[4, 5]}
            marginBottom={isLastItem ? 0 : 2}
            border={isSelected ? 2 : `1px solid ${colors.midGray}`}
            borderRadius={2}
            is='div'
            onClick={() => handleOnClickShippingMethodSelected(shippingMethod)}
        >
            <Flex
                paddingY={3}
                paddingX={4}
                justifyContent='space-between'
            >
                <Text
                    is='h3'
                    fontWeight='bold'
                    fontSize={['base', 'base', 'md']}
                    children={`${title} ${!localeUtils.isCanada() ? locales.shipping : ''}`}
                />
                <Text
                    is='h3'
                    fontWeight='bold'
                    fontSize={['base', 'base', 'md']}
                    children={shipFee}
                />
            </Flex>
            {isSelected && (
                <ShippingMethodItems
                    locales={locales}
                    isReplenOnly={isReplenOnly}
                    shippingMethod={shippingMethod}
                    deliveryGroups={deliveryGroups}
                    orderHasReplen={orderHasReplen}
                    standardItemsQuantity={standardItemsQuantity}
                    replenishItemsQuantity={replenishItemsQuantity}
                    isPhysicalGiftCard={isPhysicalGiftCard}
                    isElectronicShippingGroup={isElectronicShippingGroup}
                    isEditView={isEditView}
                    showAutoReplenishModal={showAutoReplenishModal}
                    openAutoReplenishProductsModal={openAutoReplenishProductsModal}
                    standardBasket={standardBasket}
                    message={message}
                    handleCheckboxChange={handleCheckboxChange}
                    setShippingMethod={setShippingMethod}
                />
            )}
        </Box>
    );
}

export default wrapFunctionalComponent(ShippingMethod, 'ShippingMethod');
